import type { ReactElement } from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: (value: string) => void;
  placeholder?: string;
  className?: string;
  /** Accessible name; defaults to the placeholder. */
  ariaLabel?: string;
}

/**
 * Search input with icon - reusable search field component
 */
export function SearchInput({
  value,
  onChange,
  onSubmit,
  placeholder = 'Search...',
  className = '',
  ariaLabel,
}: SearchInputProps): ReactElement {
  return (
    <div className={`relative flex-1 max-w-sm ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const currentValue =
              e.target instanceof HTMLInputElement ? e.target.value : value;
            onSubmit?.(currentValue);
          }
        }}
        className="pl-9"
      />
    </div>
  );
}
